import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageSeoTextWidget',
  props: {
    pageTitle: null,
    htmlContent: null
  },
  setup(__props: any) {

const props = __props as {
	pageTitle: string;
	htmlContent: string;
}



const viewMore = ref(false);

function toggleCollapsed() {
	viewMore.value = !viewMore.value;
}

return { __sfc: true,props, viewMore, toggleCollapsed, Icon, LinkButton }
}

})